import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// cc-common imports
import { DxWidgetUtils, IconConstants, Utils } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// model imports
import { TransactionLogResultDto } from '../../_models/common/transaction-log-result-dto';

// constant imports
import { StringFormatConstants } from '../../../../_constants/string-format-constants';

@Component({
    selector: 'app-transaction-history',
    templateUrl: './transaction-history.component.html',
    styleUrls: ['./transaction-history.component.scss']
})
export class TransactionHistoryComponent implements OnInit {
    @ViewChild('transactionLog', { static: false }) transactionLog: DxPopupComponent;

    @Input() title: string;
    @Input() communityId: number;

    @Input() transactionLogResultData: TransactionLogResultDto[] = [];
    @Output() onTransactionLogClose = new EventEmitter<boolean>();

    visible: boolean;

    loadingVisible = false;
    dateTimeFormat = StringFormatConstants.dateTimeFormat;

    iconClose = IconConstants.CLOSE;

    ngOnInit() {
        if (Utils.isNullOrUndefined(this.title)) {
            this.title = 'Transaction Log';
        }
        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onPopupShown(): void {
        DxWidgetUtils.instantRepaint(this.transactionLog);
    }

    onPopClose(): void {
        this.visible = false;
        this.transactionLogResultData = [];
        this.onTransactionLogClose.emit(this.visible);
    }
}
